export default "__VITE_ASSET__CUdIp$yl__"